"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (props) {
    return _react2.default.createElement(
        "svg",
        { width: "32", height: "32", viewBox: "0 0 32 32", className: "Icon toolbar-arrow-left-on", xmlns: "http://www.w3.org/2000/svg" },
        _react2.default.createElement(
            "g",
            { fill: "none", fillRule: "evenodd" },
            _react2.default.createElement("path", { d: "M21.582 17.726v3.933L8.84 15.738l12.743-5.132v3.934h8.924v3.186h-8.924z", fill: "#4C4C4C" }),
            _react2.default.createElement("path", { d: "M16 31C7.716 31 1 24.284 1 16 1 7.716 7.716 1 16 1c8.284 0 15 6.716 15 15 0 8.284-6.716 15-15 15z", stroke: "#000", strokeWidth: "2" })
        )
    );
}; /*eslint-disable */


//////////////////
// WEBPACK FOOTER
// ./src/client/components/icons/small/jsx/toolbar-arrow-left-on.js
// module id = 1870
// module chunks = 0